import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View, Image } from "../_core/components";
import { pxTransform } from "../_util/px-transform";
import { TaroEnv } from "../_util/env";
import { useConfig } from "../_util/use-config";
export function Icon(_a) {
    var _b = _a.size, size = _b === void 0 ? TaroEnv ? 48 : 24 : _b, _c = _a.name, name = _c === void 0 ? "" : _c, render = _a.render, color = _a.color, className = _a.className, _d = _a.style, style = _d === void 0 ? {} : _d, props = __rest(_a, ["size", "name", "render", "color", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    // 判断属性 name 的值是否为 url
    var src = name.indexOf("/") !== -1 ? name : null;
    // 生成样式
    var genStyle = function (styleProps) {
        var size = styleProps.size, color = styleProps.color, src = styleProps.src;
        var sizeStyle = src
            ? {
                width: typeof size === "number" ? pxTransform(size, 750) : size,
                height: typeof size === "number" ? pxTransform(size, 750) : size,
            }
            : {
                fontSize: typeof size === "number" ? pxTransform(size, 750) : size,
            };
        var colorStyle = { color: color };
        return __assign(__assign({}, sizeStyle), colorStyle);
    };
    if (render) {
        var renderProps = {
            size: typeof size === "number" ? pxTransform(size, 750) : size,
            color: color,
        };
        return (React.createElement(View, { className: classNames(classPrefix + "-icon", className), style: style }, render(renderProps)));
    }
    return src ? (React.createElement(View, __assign({ className: classNames(classPrefix + "-icon", className), style: style }, props),
        React.createElement(Image, { src: src, style: genStyle({ size: size, color: color, src: src }), mode: "aspectFill" }))) : (React.createElement(View, __assign({ className: classNames(classPrefix + "-icon", classPrefix + "-icon-" + name, className), style: __assign(__assign({}, style), genStyle({ size: size, color: color })) }, props)));
}
//# sourceMappingURL=Icon.js.map